export default __webpack_public_path__ + "static/media/Managed-Services_Customer-Story-Dish.dd3fd031.jpg";